var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"liquid-fill-wrapper"},[_c('VocChart',{attrs:{"option":_vm.option}}),_c('i'),_c('i'),_c('i'),_c('i'),_c('i'),_c('i')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }